@if (customEmployerLogo) {
  <p class="overline text--header">
    <img [src]="customEmployerLogo" alt="Employer Logo" class="custom-logo"/>
  </p>
} @else {
  <p class="overline text--header">
    <img src="assets/images/stiira_logo.svg" alt="Stiira Logo" class="logo" width="140px" />
  </p>
}
<a [routerLink]="myProlfilePath" (click)="handleLinkClick()">
  <img
    class="user-image"
    [src]="employeeInfo?.image || 'assets/images/missing_avatar.svg'"
    [alt]="employeeInfo?.name" />
</a>
<p class="body1 text--name">{{ employeeInfo?.name }}</p>
<p class="caption text--employer">{{ employeeInfo?.employer }}</p>
